// extracted by mini-css-extract-plugin
module.exports = {"stepNumber":"Step_stepNumber__0oHn7","step__title":"Step_step__title__k1jgq","step__description":"Step_step__description__pgo4F"};